// src/components/TagItBeaconClient.jsx
"use client";

import { useCallback, useMemo } from "react";

import TagItBeacon from "@/components/TagItBeacon";
import { getFsReads } from "@/lib/fsReads";
import { usePortal } from "@/context/PortalContext";

export default function TagItBeaconClient() {
  const portal = usePortal();
  const detailsFn = useCallback(() => String(getFsReads()), []);
  const content = useMemo(() => portal ? {
    contentType: "publisher-portal",
    contentData: {
      surfaceType: "publisher-portal",
      portalId: portal.id,
      portalHostname: portal.hostname,
    },
  } : undefined, [portal?.hostname, portal?.id]);
  return (
    <TagItBeacon
      detailsFn={detailsFn}
      content={content}
      surfaceId={portal?.id || "sproutly"}
    />
  );
}
